import React from 'react';
import RenderImg from '@op/components/RenderImg';
import type { ThumbnailGridProps } from './types';
import { DefaultImg } from '@op/constants/defaultImg';

type Layout = 'single' | 'double' | 'triple' | 'quad';

function getLayout(count: number): Layout {
  if (count === 1) return 'single';
  if (count === 2) return 'double';
  if (count === 3) return 'triple';
  return 'quad';
}

const ThumbnailGrid: React.FC<ThumbnailGridProps> = ({ images, onImageClick }) => {
  const layout = getLayout(images.length);
  const displayImages = images.slice(0, 4);
  const extraCount = images.length - 4;

  return (
    <div
      className={`dbo-image-gallery__grid dbo-image-gallery__grid--${layout}`}
    >
      {displayImages.map((url, idx) => (
        <div key={`${url}-${idx}`} className="dbo-image-gallery__thumbnail">
          <RenderImg
            coverImage={url}
            mode="image"
            onClick={() => onImageClick(idx)}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
            defaultImage={DefaultImg.VIDEO}
          />
          {layout === 'quad' && idx === 3 && extraCount > 0 && (
            <div className="dbo-image-gallery__badge">+{extraCount}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ThumbnailGrid;
